// Chakra Imports
import {
	Avatar,
	Button,
	Flex,
	Icon,
	Image,
	Link,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Text,
	useColorModeValue,
	useDisclosure
} from '@chakra-ui/react';
// Custom Components
import { ItemContent } from 'components/menu/ItemContent';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import PropTypes from 'prop-types';
import React, {useState, useEffect} from 'react';
// Assets
import navImage from 'assets/img/layout/Navbar.png';
import { MdNotificationsNone, MdInfoOutline } from 'react-icons/md';
import { FaEthereum } from 'react-icons/fa';
import routes from 'routes.js';
import { ThemeEditor } from './ThemeEditor';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useHistory } from 'react-router-dom';
import { ChangePasswordModal } from './changePasswordModal'; // <-- import
export default function HeaderLinks(props) {

	const history = useHistory();
	const handleLogout = async () => {
		// Limpar o token do AsyncStorage
		await AsyncStorage.removeItem('@storage_Key');
		// Redirecionar para a tela de login
		history.push('/login');
	};


	const { isOpen, onOpen, onClose } = useDisclosure();



	const [userEmail, setUserEmail] = useState('');

	useEffect(() => {
		AsyncStorage.getItem('@storage_Key').then(email => {
			if (email) setUserEmail(email);
		});
	}, []);

	const { secondary } = props;
	// Chakra Color Mode
	const navbarIcon = useColorModeValue('gray.400', 'white');
	let menuBg = useColorModeValue('white', 'navy.800');
	const textColor = useColorModeValue('secondaryGray.900', 'white');
	const textColorBrand = useColorModeValue('brand.700', 'brand.400');
	const ethColor = useColorModeValue('gray.700', 'white');
	const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
	const ethBg = useColorModeValue('secondaryGray.300', 'navy.900');
	const ethBox = useColorModeValue('white', 'navy.800');
	const shadow = useColorModeValue(
		'14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
		'14px 17px 40px 4px rgba(112, 144, 176, 0.06)'
	);
	const borderButton = useColorModeValue('secondaryGray.500', 'whiteAlpha.200');
	return (
		<>
			<Flex
				w={{ md: 'auto' }}
				alignItems="center"
				flexDirection="row"
				bg={menuBg}
				flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
				p="10px"
				borderRadius="30px"
				boxShadow={shadow}>
				{/* <SearchBar mb={secondary ? { base: '10px', md: 'unset' } : 'unset'} me="10px" borderRadius="30px" /> */}
				<Flex
					bg={ethBg}
					display={secondary ? 'flex' : 'none'}
					borderRadius="30px"
					ms="auto"
					p="6px"
					align="center"
					me="6px">
					<Flex align="center" justify="center" bg={ethBox} h="29px" w="29px" borderRadius="30px" me="7px">
						<Icon color={ethColor} w="9px" h="14px" as={FaEthereum} />
					</Flex>
					<Text w="max-content" color={ethColor} fontSize="sm" fontWeight="700" me="6px">
						1,924
						<Text as="span" display={{ base: 'none', md: 'unset' }}>
							{' '}
							ETH
						</Text>
					</Text>
				</Flex>
				<SidebarResponsive routes={routes} />
				<Menu>
					<MenuButton p="0px">
						<Avatar
							_hover={{ cursor: 'pointer' }}
							color="white"
							name="B I"
							bg="#11047A"
							size="sm"
							w="40px"
							h="40px"
						/>
					</MenuButton>
					<MenuList boxShadow={shadow} p="0px" mt="10px" borderRadius="20px" bg={menuBg} border="none">
						<Flex w="100%" mb="0px">
							<Text
								ps="20px"
								pt="16px"
								pb="10px"
								w="100%"
								borderBottom="1px solid"
								borderColor={borderColor}
								fontSize="sm"
								fontWeight="700"
								color={textColor}>
								👋&nbsp; Bem vindo
							</Text>
						</Flex>
						<Flex flexDirection="column" p="10px">
							{/* <MenuItem _hover={{ bg: 'none' }} _focus={{ bg: 'none' }} borderRadius="8px" px="14px">
							<Text fontSize="sm">Profile Settings</Text>
						</MenuItem>
						<MenuItem _hover={{ bg: 'none' }} _focus={{ bg: 'none' }} borderRadius="8px" px="14px">
							<Text fontSize="sm">Newsletter Settings</Text>
						</MenuItem> */}
							<MenuItem
								onClick={onOpen}
								_hover={{ bg: 'none' }}
								_focus={{ bg: 'none' }}
								borderRadius="8px"
								px="14px"
							>
								<Text fontSize="sm">Alterar Senha</Text>
							</MenuItem>
							<MenuItem
								onClick={handleLogout}
								_hover={{ bg: 'none' }}
								_focus={{ bg: 'none' }}
								color="red.400"
								borderRadius="8px"
								px="14px">
								<Text fontSize="sm">Sair</Text>
							</MenuItem>
						</Flex>
					</MenuList>
				</Menu>
			</Flex>
			{/* Aqui está o modal desacoplado */}
			<ChangePasswordModal
				isOpen={isOpen}
				onClose={onClose}
				userEmail={userEmail}
			/>
		</>
	);
}

HeaderLinks.propTypes = {
	variant: PropTypes.string,
	fixed: PropTypes.bool,
	secondary: PropTypes.bool,
	onOpen: PropTypes.func
};

